<template>
	<div id="searchContainer" class="search-container">
		<div class="search-main" v-if="thematicBoolean || queryServiceBoolean || serviceNewsBoolean">
			<!--   专题服务   -->
			<div class="thematic-service" v-if="thematicServices.length>0">
				<p class="title">
					<span>专题服务</span>
					<span
						class="right color999"
						@click="thematicHandle"
					>更多></span>
				</p>
				<ul class="service-list">
					<li class="list-item" v-for="(item,index) in thematicServices" :key="index"
					    @click="serviceDetailHandle(item)">
						<div class="info-box">
							<p class="info-title color333">{{ item.speciaName }}</p>
							<p class="info color999">{{ item.speciaSub }}</p>
						</div>
						<div class="icon-box">
							<img
								class="icon-img"
								onload="SVGInject(this)"
								round fit="cover"
								:src="complete(item.speciaIcon)"
							/>
						</div>
					</li>
				</ul>
			</div>
			<!--   一事联办   -->
			<div class="event-service" v-if="queryServiceList.length > 0">
				<p class="title">
					<span>一事联办</span>
					<span
						class="right color999"
						@click="serviceHandle"
					>更多></span>
				</p>
				<ul class="event-list">
					<li v-for="(item, index) in queryServiceList" :key="index" class="list-item"
					    @click="serviceJump(item)">
						<p class="icon-box">
							<img
								class="icon-img"
								onload="SVGInject(this)"
								round fit="cover"
								:src="complete(item.icon)"
							/>
						</p>
						<p class="item-title color333">{{ item.name }}</p>
					</li>
				</ul>
			</div>
			<!--   服务资讯   -->
			<div class="service-news" v-if="serviceNews.length>0">
				<p class="title">
					<span>服务资讯</span>
					<span
						class="right color999"
						@click="newsHandle"
					>更多></span>
				</p>
				<div class="service-news-container">
					<div v-for="(item, index) in serviceNews" :key="index" @click="goDetail(item)">
						<div class="news-box" v-if="index < 3">
							<p class="title color333">{{ item.title }}</p>
							<p class="from color999">
								<span>{{ item.publishdate }}</span>
								<span>{{ item.orgname }}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="search-main empty" v-else>
			<Error :type="'searchEmpty'"></Error>
		</div>
	</div>
</template>

<script>
import {complete, baseURL} from "@/utils/url"
import {getThematicService, queryServiceNews} from '@/api/home/index' // 专题服务/服务资讯
import {queryServices} from '@/api/service-hall' // 一事联办
import {serviceJump} from "@/utils/serviceUtil"

export default {
	data() {
		return {
			baseURL: baseURL,
			search: '',
			thematicServices: [],
			queryServiceList: [],
			serviceNews: [],
			thematicBoolean: true,
			queryServiceBoolean: true,
			serviceNewsBoolean: true
		}
	},
	created() {
		//window.history.pushState(null, null, document.URL)
		this.init();
	},
	methods: {
		// 声明complete方法
		complete, serviceJump,
		// init初始化事件
		init() {
			this.search = this.$route.query.search;
			//获取专题服务
			getThematicService({key: this.search, useType: 2}).then(res => {
				if (res.code && res.code == 200) {
					this.thematicServices = res.data.data || [];
					this.thematicServices.length > 0 ? this.thematicBoolean = true : this.thematicBoolean = false
				}
			})
			//获取一事联办
			queryServices({keyword: this.search, useType: 2, pageSize: 99}).then(res => {
				if (res.code && res.code == 200) {
					if (res.data && res.data.data) {
						res.data.data.length > 0 ? this.queryServiceBoolean = true : this.queryServiceBoolean = false
						res.data.data.forEach((item, index) => {
							if (index < 8) {
								this.queryServiceList.push(item)
							}
						})
					}

				}
			})
			// 获取服务资讯
			queryServiceNews({title: this.search}).then(res => {
				if (res.code && res.code == 200) {
					this.serviceNews = res.data.data || [];
					this.serviceNews.length > 0 ? this.serviceNewsBoolean = true : this.serviceNewsBoolean = false
				}
			})
		},
		// 专题服务点击事件
		serviceDetailHandle(item) {
			this.$router.push('/project/details/' + item.id)
		},
		// 咨讯详情
		goDetail(item) {
			this.$router.push('/serviceNews/detail/' + item.id)
		},
		// 专题更多
		thematicHandle() {
			this.$router.push('/project');
		},
		// 办事更多
		serviceHandle() {
			this.$router.push('/homeTab/serviceHall');
		},
		// 资讯更多
		newsHandle() {
			this.$router.push('/serviceNews');
		},
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/theme/theme";

.search-main {
	min-height: 100vh;
	padding: 15px;
	box-sizing: border-box;
	overflow-y: auto;
	background: #f7f7f7;

	&.grayBg {
		background: #f7f7f7;
	}

	.title {
		height: 45px;
		line-height: 45px;
		display: flex;
		justify-content: space-between;
		@extend .color333;
		@extend .font16;

		span.right, .iconfont {
			@extend .font13;
		}
	}
}

.service-list {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;

	.list-item {
		width: 166px;
		box-sizing: border-box;
		padding: 12px;
		margin-bottom: 10px;
		background: #fff;
		border-radius: 7px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.info-box {
			width: 90px;

			.info-title {
				height: 25px;
				line-height: 25px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				@extend .font16;
			}

			.info {
				height: 36px;
				line-height: 18px;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				@extend .font13;
			}
		}

		.icon-box {
			.iconfont {
				font-size: 33px;
				color: var(--main-color);
			}

			img {
				width: 33px;
			}
		}
	}
}

.event-list {
	display: flex;
	flex-wrap: wrap;
	padding: 10px 15px;
	margin-bottom: 10px;
	border-radius: 5px;
	background: #fff;

	.list-item {
		width: 70px;
		margin: 10px 0;
		margin-right: 11px;
		text-align: center;

		&:nth-child(4n) {
			margin-right: 0;
		}

		.icon-box {
			text-align: center;
			margin-bottom: 10px;

			.iconfont {
				font-size: 23px;
				color: var(--main-color);
			}

			img {
				height: 23px;
			}
		}

		.item-title {
			height: 44px;
			line-height: 22px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			@extend .font13;
		}
	}
}

.service-news-container {
	padding: 15px 0;

	.news-box {
		padding: 15px;
		background: #fff;
		border-radius: 5px;
		margin-bottom: 15px;

		.title {
			height: 48px;
			line-height: 24px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			word-break: break-all;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			margin-bottom: 5px;
			@extend .font16;
		}

		.from {
			height: 20px;
			line-height: 20px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			@extend .font13;

			span:first-child {
				margin-right: 2em;
			}
		}

		&:last-child {
			margin-bottom: 0;
		}
	}
}

.empty {
	margin-top: 100px;
}
</style>
